import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom'

import { useAbortableLoad } from '../../Hooks'


import "./style.css";
import WorkOrderEditor from "../../Components/WorkOrderEditor";
import ContentContainer from "../../Components/ContentContainer/ContentContainer.js";
import SaveStatus from "../../UIComponents/SaveStatus/index.js";

import mapStateToProps from './mapStateToProps.js'
import { Typography } from "@mui/material";


const WorkOrderOperation = ({ variant }) => {


  const { docId, sheduleId, workId } = useParams();
  const {
    // singleDocument,
    // singleDocument: {
    //   data: {
    //     id:{ rawValue: id } = {},
    //     number:{ rawValue: number } = {},
    //     date:{ rawValue: date= new Date().valueOf() } = {},
    //     company:{ rawValue: company } = {},
    //     project:{ rawValue: project } = {},
    //     plan:{ rawValue: plan = parseInt(sheduleId) } = {},
    //     workType:{ rawValue: workType =  parseInt(workId)} = {},
    //     period:{ rawValue: period } = {},
    //     performers:{ rawValue: performers } = {}, //мусор. Это поле только вычисляемое
    //     teams:{ rawValue: teams }={},
    //     status:{ rawValue: status } = {},//мусор
    //     availableStatuses:{ rawValue: availableStatuses } = {},//мусор
    //     dataArr:dataArrIncoming = []
    //   } = {},
    // } = {},
    addingDocument,
    savingDocument,
    rights,
    // getSingleDocument = () => { },
    addDocument = () => { },
    saveDocument = () => { },
    getPlanWorkDir = () => { },
    // setSingleDocument = () => { },
  } = useSelector(mapStateToProps)


  const singleDocument = useAbortableLoad(
    'getSingleDocument',
    'singleDocument',
    { docId: "orderWork", id: docId },
    variant !== 'add',
    [docId, variant !== 'add'],
    'setSingleDocument'
  );

  const calculatedPlancheduleId = variant === 'add'?(sheduleId):((variant === 'edit' && singleDocument?.data?.plan?.rawValue)?(singleDocument.data.plan.rawValue):undefined)

  //Загрузка альтернативы данных, чтоб было откуда подтянуть проект, компанию
  const dataSource = useAbortableLoad(
    'getSingleDocument2',
    'singleDocument2',
    {
      docId: "planSchedule",
      id: calculatedPlancheduleId
    },
    variant === 'add' || (variant === 'edit' && singleDocument?.data?.plan?.rawValue),
    [docId, calculatedPlancheduleId],
    'setSingleDocument2'
  );

  const {
    data: {
      company: { rawValue: company_PS } = {},
      project: { rawValue: project_PS } = {},
      dataArr: sourceDataArr = [],
    } = {},
  } = dataSource || {};

  //workId
  const defaultFrom = sourceDataArr?.find(({ workType }) => workType?.rawValue == workId)?.start?.rawValue
  const defaultTo = sourceDataArr?.find(({ workType }) => workType?.rawValue == workId)?.end?.rawValue

  const {
    data: {
      id: { rawValue: id } = {},
      number: { rawValue: number } = {},
      date: { rawValue: date = new Date().valueOf() } = {},
      company: { rawValue: company = company_PS } = {},
      project: { rawValue: project = project_PS } = {},
      plan: { rawValue: plan = parseInt(sheduleId) } = {},
      workType: { rawValue: workType = parseInt(workId) } = {},
      periodFrom: { rawValue: periodFrom = defaultFrom ||  new Date().valueOf() } = {},
      periodTo: { rawValue: periodTo = defaultTo || new Date().valueOf() } = {},
      performers: { rawValue: performers } = {}, //мусор. Это поле только вычисляемое
      teams: { rawValue: teams } = {},
      status: { value: demoStatus } = {},//ридонли
      preparedBy: { preparedBy: preparedBy } = {},
      geozone: { rawValue: geozone } = {},
      carriedOut: { rawValue: carriedOut = false } = {},
      availableStatuses: { rawValue: availableStatuses } = {},//мусор
      dataArr: dataArrIncoming = []
    } = {},
  } = singleDocument || {};

  const dataArr = dataArrIncoming?.map((item) => {
    const {
      id: { rawValue: id } = {},
      number: { rawValue: number } = {},
      order: { rawValue: order } = {},//мусор
      worker: { rawValue: worker } = {},
      team: { rawValue: team } = {},
      tracker: { rawValue: tracker } = {},
      scopePlan: { rawValue: scopePlan } = {},
      scopeFact: { rawValue: scopeFact } = {},
      startDate: { rawValue: startDate } = {},//Начало работ (факт)
      endDate: { rawValue: endDate } = {},//Окончание работ (факт)
      planedStartDate: { rawValue: planedStartDate } = {},//Начало работ (факт)
      planedEndDate: { rawValue: planedEndDate } = {},//Окончание работ (факт)
      note: { rawValue: note } = {},
    } = item
    return {
      id,
      number,
      order,
      worker,
      team,
      tracker,
      scopePlan,
      scopeFact,
      startDate,
      endDate,
      planedStartDate,
      planedEndDate,
      note,
    }
  })

  const calculatedPerformers = dataArrIncoming?.map(({ worker } = {}) => worker?.value)?.filter(item => !!item)?.join();

  const fields = {
    id,
    number,
    date,
    company,
    project,
    plan,
    workType,
    periodFrom,
    periodTo,
    performers: calculatedPerformers,
    teams,
    demoStatus, //мусор
    preparedBy,
    geozone,
    carriedOut,
    availableStatuses, //мусор
    dataArr,
    isView: (variant === 'view')
  }

  /**Признак того, что все данные формы готовы к работе */
  const isReady = (dataSource && !dataSource.loading) || (singleDocument && !singleDocument.loading);


  const history = useHistory()


  let saver = () => { };
  if (variant === "edit") {
    saver = (fields) => {
      saveDocument({
        docId: "orderWork",
        fields
      })
    }

  } else if (variant === "add") {
    saver = (fields) => {
      addDocument({
        docId: "orderWork",
        fields
      })
    }
  }


  useEffect(() => {
    //Этот эффект служит для запроса якобы справочника (якобы-т.к. он живет на отдельной точке АПИ) с видами работ доступными в 
    //конкретном ПГ
    if (plan) {
      getPlanWorkDir({
        docId: "planSchedule",
        id: plan
      })
    }

  }, [plan])


  const postSaveAction = () => {
    history.push('/document/work-order')
  }


  //правовые предохранители
  if (variant === 'add' && !rights?.['order-create']) return null;
  if (variant === 'edit' && !rights?.['order-edit']) return null;
  if (variant === 'view' && !rights?.['order-view']) return null;


  return (
    <ContentContainer
      content={
        <>
          <SaveStatus dataObj={singleDocument} errShowTime={1000} successShowTime={100} />
          {isReady ? (
            <WorkOrderEditor
              // defaultFrom={periodFrom_PS}
              // defaultTo={periodTo_PS}
              planWorkArr={sourceDataArr}
              variant={variant}
              saver={saver}
              fields={fields}
              rights={rights}
              addingDocument={addingDocument}
              savingDocument={savingDocument}
              postSaveAction={postSaveAction}
            />
          ) : null}
        </>
      }
    />

  )
}
export default WorkOrderOperation
